import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';

const StyledSpecialCallOut = styled.div`
	border-radius: ${(props) => (props.roundedCorners ? '0 60px' : '0')};
	overflow: hidden;

	${EmotionBreakpoint('notMobile')} {
		height: 300px;
		flex-direction: ${(props) =>
			props.imageAlignment === 'right' ? 'row-reverse' : 'row'};
	}
`;

const StyledSpecialCallOutImage = styled.div`
	@media (min-width: 768px) and (max-width: 991px) {
		width: 40%;
	}

	${EmotionBreakpoint('desktop')} {
		width: 51%;
	}

	${EmotionBreakpoint('notMobile')} {
		height: 100%;
		overflow: hidden;

		img {
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			right: 0;
			margin: auto;
		}
	}

	${EmotionBreakpoint('mobile')} {
		width: 100%;

		img {
			width: 100%;
		}
	}
`;

const StyledSpecialCallOutContent = styled.div`
	background-color: ${(props) => props.backgroundColor || '#000000'};

	@media (min-width: 1170px) {
		padding: 60px 50px 60px 40px;
	}

	@media (min-width: 768px) and (max-width: 991px) {
		width: 60%;
	}

	${EmotionBreakpoint('desktop')} {
		width: 49%;
	}

	${EmotionBreakpoint('notMobile')} {
		padding: 40px;
		height: 100%;
	}

	${EmotionBreakpoint('mobile')} {
		width: 100%;
		padding: 28px 20px 30px;
	}

	h2 {
		font-size: ${(props) => (props.titleFontSize || '40') + 'px'};
		line-height: ${(props) => (props.titleLineHeight || '48') + 'px'};
		letter-spacing: -0.5px;
		color: ${(props) => props.titleColor || '#ffffff'};

		${EmotionBreakpoint('mobile')} {
			font-size: 24px;
			line-height: 32px;
		}
	}

	p {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: ${(props) => props.copyColor || '#ffffff'};
	}
`;

function SpecialCallOut({
	props: {
		title,
		titleColor,
		titleFontSize,
		titleLineHeight,
		link,
		image,
		imageUrl,
		copyColor,
		copy,
		buttonStyle,
		buttonCopy,
		backgroundColor,
		roundedCorners,
		imageAlignment,
	},
}) {
	return (
		<div className='container'>
			<StyledSpecialCallOut
				className='d-md-flex justify-content-center align-items-start'
				roundedCorners={roundedCorners}
				imageAlignment={imageAlignment}
			>
				<StyledSpecialCallOutImage className='position-relative'>
					<img
						src={image?.fields?.file?.url || imageUrl}
						alt={title}
						title={title}
						className='d-inline-block'
					/>
				</StyledSpecialCallOutImage>
				<StyledSpecialCallOutContent
					titleColor={titleColor}
					copyColor={copyColor}
					titleFontSize={titleFontSize}
					titleLineHeight={titleLineHeight}
					backgroundColor={backgroundColor}
				>
					<h2 className='mb-16 lower'>{title}</h2>
					<p className='mb-20'>{copy}</p>
					<div className='text-center text-md-left'>
						<a href={link} className={'btn btn-' + buttonStyle}>
							{buttonCopy}
						</a>
					</div>
				</StyledSpecialCallOutContent>
			</StyledSpecialCallOut>
		</div>
	);
}

export default SpecialCallOut;
